import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';

const ICON_AMAZON = () => (
    <svg className="icon-amazon" xmlns="http://www.w3.org/2000/svg" width="32" height="9" viewBox="0 0 32 9" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.1903 2.61699C29.7493 2.03263 27.2752 2.3365 26.1633 2.47675C25.826 2.5196 25.7741 2.20989 26.078 1.98589C28.0517 0.528886 31.2856 0.949624 31.6618 1.43659C32.038 1.92355 31.5617 5.33231 29.7122 6.96267C29.4268 7.212 29.1562 7.07954 29.2841 6.74841C29.6992 5.65566 30.6314 3.21109 30.1903 2.61699Z"
            fill="#FF9900"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.7565 4.33883C25.3095 7.01324 20.3094 8.42934 16.0062 8.42934C10.2583 8.45832 4.70697 6.23139 0.439064 2.1845C0.114748 1.88453 0.394587 1.46574 0.783766 1.69948C5.52911 4.5512 10.9014 6.04929 16.3676 6.04515C20.4514 6.02377 24.491 5.15462 28.2543 3.48762C28.8399 3.23245 29.3273 3.89472 28.7565 4.33883Z"
            fill="#FF9900"
        />
    </svg>
);

export default function IndexDynamic() {
    return (
        <>
            <B />
            <C />
            <D ICON_AMAZON={ICON_AMAZON} />
            <E ICON_AMAZON={ICON_AMAZON} />
            <F ICON_AMAZON={ICON_AMAZON} />
            <G />
            <H />
        </>
    );
}
